import Util from "../util/util";

Util.ifSelector(".vm-redirect-page", () =>
{
	//auto submit the form
	$("#vm-form").submit();
});